'use strict';

export default class ParagraphTypeSlick {
    constructor() {
        this.name = 'paragraph--type--slick';

        var slideItems = $(".paragraph--type--slick .field--name-field-images > .field__item").length;
        var minimum = 3;
        let slickOptions = {
            dots: false,
            autoplay: true,
            pauseOnHover: false,
            swipeToSlide: true,
            infinite: false,
            pauseOnFocus: false,
            infinite: true,
            variableWidth: true,
            centerMode: true,
            dots: false,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 7000,
            arrows: false,
            cssEase: 'linear',
            slidesToScroll: 1

        };



        // if (slideItems < minimum) {
        //     track.addClass('slick-initialized');
        //     return;
        // }




        // Drupal.behaviors.mySlickSomethingBehavior = {
        //     attach: function (context, settings) {
        //         once('mySlickSomethingBehavior', 'html').forEach(function (element) {
        //             $(".paragraph--type--slick").each(function () {
        //                 var track = $(this).find(".field--name-field-images")

        //                 //console.log($count);

        //                 if ($('body').hasClass("page-node-type-work")) {
        //                     minimum = 3;
        //                     slideItems = $(track).find('.field__item').length;
        //                 }



        //                 if ($(this).hasClass('slick-slider-slider')) {
        //                     minimum = 2;

        //                     slickOptions = {
        //                         ...slickOptions,
        //                         slidsToShow: 1,
        //                         variableWidth: false,
        //                         centerMode: false,
        //                         infinite: false,
        //                         autoplay: false,
        //                         cssEase: 'ease-in-out',
        //                         // autoplaySpeed: 2000,
        //                         pauseOnFocus: true,

        //                         pauseOnHover: true,
        //                         speed: 500,
        //                         swipeToSlide: true,
        //                         arrows: true
        //                     }
        //                 }
        //                 if ($(this).hasClass('slick-slider-carousel')) {
        //                     minimum = 3;
        //                     slideItems = $(track).find('.field__item').length;

        //                 }

        //                 if (slideItems < minimum) {
        //                     track.addClass('slick-initialized');
        //                     return;
        //                 }

        //                 track.slick(slickOptions);
        //             });
        //         })
        //     }
        // }
        $(".paragraph--type--slick").each(function () {
            var track = $(this).find(".field--name-field-images")
            let attempt = 0;
            let init = false;

            if ($('body').hasClass("page-node-type-work")) {
                minimum = 3;
                slideItems = $(track).find('.field__item').length;
            }
            if ($(this).hasClass("none")) {
                minimum = 3;
                slideItems = $(track).find('.field__item').length;
            }
            if ($(this).hasClass('slick-slider-slider')) {
                minimum = 2;

                slickOptions = {
                    ...slickOptions,
                    slidesToShow: 1,
                    variableWidth: false,
                    centerMode: false,
                    infinite: false,
                    autoplay: false,
                    cssEase: 'ease-in-out',
                    // autoplaySpeed: 2000,
                    pauseOnFocus: true,
                    pauseOnHover: true,
                    speed: 500,
                    swipeToSlide: true,
                    arrows: true
                }
                console.log(slickOptions, "slick options inside carousel");
            }
            if ($(this).hasClass('slick-slider-carousel')) {
                minimum = 2;
                slideItems = $(track).find('.field__item').length;
                slickOptions = {
                    dots: false,
                    autoplay: true,
                    pauseOnHover: false,
                    swipeToSlide: true,
                    infinite: false,
                    pauseOnFocus: false,
                    infinite: true,
                    variableWidth: true,
                    centerMode: true,
                    dots: false,
                    autoplay: true,
                    autoplaySpeed: 0,
                    speed: 7000,
                    arrows: false,
                    cssEase: 'linear',
                    slidesToScroll: 1
                }
            }

            if (slideItems < minimum) {
                track.addClass('slick-initialized');
                return;
            }
            track.slick(slickOptions);
            
            track.find('img').on('load', function () {
                if (this.complete) {
                    try {
                        if(!track.hasClass('slick-initialized')) track.slick(slickOptions);
                    } catch (e) {
                        console.log(track);
                        console.log(e);
                    }
                }
            });

            return;
            // Code to run after the carousel has been initialized
            track.on('init', function (event, slick) {
                // different approach after trying more than 5 times
                if (attempt >= 5) {
                    attempt = 0;
                    track.slick('unslick');
                    console.log("More than 5 attempt. Enabeling image load");

                    var images = track.find('img');

                    // trigger slick initialization on image load
                    images.on('load', function () {
                        track.slick('unslick');
                        track.slick(slickOptions);
                    });

                    return;
                }


                // checking if the carousel is loaded properly 
                if (slick.listWidth <= 0) {
                    setTimeout(() => {
                        track.slick('unslick');
                        track.slick(slickOptions);
                        attempt++;
                    }, 1000); // trying to reinitialize slick after 1 second
                }
            });

            track.slick(slickOptions);
        });
    }
}
